import { render, staticRenderFns } from "./TemplateCompetitorDetailsTable.vue?vue&type=template&id=b322c096&"
import script from "./TemplateCompetitorDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./TemplateCompetitorDetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports